import React from 'react';
import { UseFormRegister, UseFormWatch } from 'react-hook-form';
import { RadioInput } from 'components/form';
import { QUESTION_CARD, QUESTION_TITLE, QUESTION_SUBTITLE, QUESTION_OPTIONS } from '../card-classes';

interface Option {
  label: string;
  value: string;
}

interface QuestionMultiCheckboxProps {
  register: UseFormRegister<any>;
  watch: UseFormWatch<any>;
  errors: any;
  name: string;
  options: Option[];
  questionText: string;
  questionNumber: number;
  maxSelections: number;
  labelText: string;
  containerClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
  radioContainerClassName?: string;
}

export const QuestionMultiCheckbox: React.FC<QuestionMultiCheckboxProps> = ({
  register,
  watch,
  errors,
  name,
  options,
  questionText,
  questionNumber,
  maxSelections,
  labelText,
  containerClassName,
  titleClassName,
  subtitleClassName,
  radioContainerClassName,
}) => {
  const selectedOptions = watch(name) || [];
  const selectedValues = Array.isArray(selectedOptions) ? selectedOptions.filter((v: any): v is string => typeof v === 'string') : [];

  return (
    <div className={`${QUESTION_CARD} ${containerClassName || ''}`}>
      <h3 className={`${QUESTION_TITLE} ${titleClassName || ''}`}>
        {questionNumber}. {questionText}
      </h3>
      <p className={`${QUESTION_SUBTITLE} ${subtitleClassName || ''}`}>
        {labelText}
      </p>
      <RadioInput
        register={register}
        name={name}
        options={options}
        type="checkbox"
        parentClassName={`${QUESTION_OPTIONS} ${radioContainerClassName || ''}`}
        validatorMessage={errors?.[name]?.message}
        disabled={selectedValues.length >= maxSelections}
        checkValue={selectedValues}
      />
    </div>
  );
};